/** Tags des modules produit — mapping distinct de `platform-tags.js` (même dossier). */
const TONE_BY_MODULE_TAG = Object.freeze({
  new: 'primary',
  beta: 'warning',
  old: 'neutral',
  maintenance: 'orange',
  ai: 'ai',
});

export function getModuleTagTone(tag) {
  if (typeof tag !== 'string' || !tag) return 'neutral';
  return TONE_BY_MODULE_TAG[tag] || 'neutral';
}

export function getModuleTagIcon(tag) {
  return tag === 'ai' ? 'ai' : null;
}
